export const testThemeStatuses: Readonly<any> = {
    TEST_FAILED: 'testFailed',
    TEST_SUCCESS_WARNINGS: 'testWarning',
    TEST_RUNNING: () => testThemeStatuses.TEST_SUCCESS_WARNINGS,
    NOT_TESTED: () => testThemeStatuses.TEST_FAILED,
    TEST_SUCCEEDED: 'testSuccedded'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/testThemeStatuses.ts